<template>
    <div class="modal_size">
        <a href="javascript:" class="ui_close" type="button" rel="modal:close" @click="$emit('close')"><span class="sr_only">popup close</span></a>
        <dl class="modal_content">
            <dt class="ellipsis maintit">
                <i>Notice</i>
            </dt>
            <dd>
                <div class="view_cont">
                    <!-- Grid -->
                    <div class="grid_wrap">
                        <!-- Grid Count-->
                        <div class="grid_total">
                            Total Count
                            <em>{{ resultCount | numberFormat }}</em>
                        </div>
                        <!-- Grid -->
                        <div id="grid">
                            <toast-grid
                                gridId="gridNoticeList"
                                :key="gridKey"
                                :data="gridData"
                                :columns="gridColumns"
                                :options="gridOptions"
                                :pageOptions="gridPageOptions"
                                :theme="gridTheme"
                                :isTotalCount="false"
                                v-bind:click="onRowClick"
                            />
                        </div>

                        <div class="paginate">
                            <sdl-pagination
                                :current-page="currentPage"
                                :total-rows="resultCount"
                                :per-page="perPage"
                                @change="onGoToPage"
                                align="center"
                            />
                        </div>
                    </div>

                    <div class="btn_wrap topLine">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">Close</a>
                        </div>
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script>

import Vue from 'vue';
import { mapGetters } from 'vuex';

import axios from 'axios';
import qs from 'query-string';

import { SDLUtil, } from '@/utils';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';
import NoticeViewPopup from './NoticeViewPopup';

const MODE = {
    SEARCH: 1,
    VIEW: 2,
};

export default {
    name: '',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
	data() {
		return {

            MODE,
            mode: MODE.SEARCH,

            view: {
                seq: '',
            },

            searchTitle: '',
            searchPopupYN: '',
            // searchRhqCode: '',
            // searchCorpCode: '',

            searchSubsidiaries: 'SEHQ',

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridColumns: [
                {
                    header: 'Subject',
                    name: 'TITLE',
                    align: 'left',
                    minWidth: 240,
                    sortable: false,
                    className: 'cur_pointer',
                },
                {
                    header: 'Registered by',
                    name: 'REGUSERNAME',
                    width: 200,
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Popup',
                    name: 'POPUPYN',
                    align: 'center',
                    width: 70,
                    sortable: false,
                },
                {
                    header: 'Period',
                    name: 'DATE',
                    align: 'center',
                    sortable: false,
                },
                {
                    header: 'Status',
                    name: 'STATUS',
                    align: 'center',
                    width: 150,
                    sortable: true,
                },
            ],
            gridOptions: {
                scrollX: true,
                scrollY: true,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },

		}
	},
	computed: {

	},
	created() {
        this.initLoad();

	},
	mounted() {

	},
	methods: {
        async initLoad() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchList(this.currentPage)
            SDLUtil.showLoadingBar(false);
            if (data === false) {
                return;
            }
            this.setData(data);
        },
        getCompanyName() {
            return JSON.parse(localStorage.getItem('loginUser')).companyName;
        },
        fetchList(pageNo) {
            if (!pageNo) pageNo = 1;

            const formData = {
                page: pageNo,
                // searchSubsidiaries: this.getCompanyName(),
            };
            const path = '/basis/admin/other/notice/GetNoticeList.skp';
            return SDLUtil.postForm(path, formData);
        },
        setData(data) {
            const { count, rows } = data;
            this.resultCount = count;
            this.setGridData(rows);
            return ;
        },
        setGridData(data) {
            this.gridData = data.map(item => {
                if (item.STARTDATE && item.ENDDATE) {
                    item.DATE = `${item.STARTDATE} - ${item.ENDDATE}`;
                }
                item.STATUS = item.STATUS === 'N' ? 'Normal' : 'Important';
                return item;
            });
            this.gridKey += 1;
        },
        onGoToPage(pageNo) {
            this.goToPage(pageNo);
        },
        async goToPage(pageNo) {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchList(this.currentPage); // .then(this.setData);
            if (data === false) {
                SDLUtil.alert({
                    title: 'Server Error',
                    msg: 'Please try again.',
                });
                return;
            }
            this.setData(data);
            this.currentPage = pageNo;
            SDLUtil.showLoadingBar(false);
        },

        onRowClick(event, rowData) {
            Vue.$log.info('▶ NoticeCreate.vue onRowClick', event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            Vue.$log.info('▶ NoticeCreate.vue onRowClick event row', rowData[event.rowKey]);
            this.openNoticeViewPopup(row.NOTICESEQ.toString());
        },

        openNoticeViewPopup(noticeSeq) {
            SDLUtil.show(
                NoticeViewPopup,
                {
                    seq: noticeSeq,
                },
                {
                    height: 'auto',
                }
            );

        },

	},
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/other/NoticeListPopup.vue